import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  },
  {
    path: '/en',
    name: 'Home-en',
    component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  },
  // {
  //   path: '/ru',
  //   name: 'Home-ru',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  // },
  // {
  //   path: '/tw',
  //   name: 'Home-tw',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  // },
  // {
  //   path: '/ko',
  //   name: 'Home-ko',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  // },
  // {
  //   path: '/ja',
  //   name: 'Home-ja',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  // },
  // {
  //   path: '/th',
  //   name: 'Home-th',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  // },
]

const router = new VueRouter({
  routes
})

export default router
